import type {Schemas} from 'domainTypes/dto';
import {sortMarcdata} from '../functions/sortMarcdata';

export const mapAuthority = (
  authority: Schemas.Authority,
): Schemas.Authority => {
  return {
    ...authority,
    marcdata: authority?.marcdata
      ? sortMarcdata(authority.marcdata)
      : undefined,
  };
};
